import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { I18n } from 'legacy/components/I18n/i18n'

import { useAnalytics } from '../hooks/useAnalytics'
import { useTopOffers } from '../LoadBoard/TopOffers/useTopOffers'
import { OfferCardFeedbackModal } from './OfferCardFeedbackModal'

const FeedbackWrapper = styled.div`
  padding: 6px 10px;

  background-color: ${getToken('color-neutral-lighter')};
`

const FeebackText = styled.span`
  color: ${getToken('color-neutral-darkest')};
  font-size: 12px;
  text-transform: uppercase;
`

const FeedbackButton = styled.button`
  margin-left: 8px;
  padding: 4px 16px;

  color: ${getToken('color-neutral-dark')};
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;

  background: transparent;
  border: 1px solid ${getToken('color-neutral-dark')};
  border-radius: 4px;

  transition: color 150ms, background 150ms;

  &:hover {
    opacity: 0.7;
  }
`

const FeedbackContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

function OfferCardFeedback(props) {
  const { uuid, forceMobile } = props
  const { removeTopOffer } = useTopOffers()
  const [isModalOpen, setModalOpen] = useState(false)
  const [isRemovingTopOffer, setIsRemovingTopOffer] = useState(false)
  const { analytics } = useAnalytics()

  useEffect(() => {
    if (!isModalOpen && isRemovingTopOffer) {
      removeTopOffer(uuid)
    }
  }, [isModalOpen, isRemovingTopOffer, removeTopOffer, uuid])

  function handleClick(event) {
    event.preventDefault()
    event.stopPropagation()
    setModalOpen(true)
  }

  function handleClose() {
    setModalOpen(false)
  }

  function handleSubmit(motives) {
    analytics.track(['Top Offers', 'Feedback'], {
      motives,
      offer: uuid,
    })
    setModalOpen(false)
    setIsRemovingTopOffer(true)
  }

  return (
    <FeedbackWrapper>
      <FeedbackContainer>
        <FeebackText>{I18n.get('lb.offerCard.feedback.text')}</FeebackText>
        <FeedbackButton type="button" forceMobile={forceMobile} onClick={handleClick}>
          {I18n.get('lb.offerCard.feedback.cta')}
        </FeedbackButton>
      </FeedbackContainer>
      <OfferCardFeedbackModal isOpen={isModalOpen} onClose={handleClose} onSubmit={handleSubmit} />
    </FeedbackWrapper>
  )
}

OfferCardFeedback.propTypes = {
  uuid: PropTypes.string.isRequired,
  forceMobile: PropTypes.bool,
}

OfferCardFeedback.defaultProps = {
  forceMobile: false,
}

export { OfferCardFeedback }
